import React, { useContext, useEffect, useState } from "react";
import "./ArticleDetail.css";
import "./ResponsiveArticleDetail.css";
import FooterTwo from "../../../components/footerTwo/FooterTwo";
import axios from "../../../services/axios";
import { useNavigate, useParams } from "react-router-dom";
import { dataContext } from "../../../context/DataContextProviderr";
import { truncate } from "../../../helper/function";
import LoadingPage from "../../../components/loadingPage/LoadingPage";
import ScrollAnimation from "react-animate-on-scroll";

const ArticleDetail = () => {
  const { isLoadingNews, allNews, homeNews } = useContext(dataContext);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const { id } = useParams();
  const { seoUrlTitle } = useParams();

  //navigate
  const navigate = useNavigate();
  const navigateHandler = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  //news detail
  const [newsDetail, setNewsDetail] = useState([]);
  const getNewsDetail = async () => {
    const response = await axios.get(
      `/api/V1/Ui/Article/GetArticleDetailForUi/${id}`,
      {
        headers: {
          SubSystemKey: window.Configs["sub-system-key"],
        },
      }
    );
    return response.data.data;
  };

  useEffect(() => {
    const fetchApiNews = async () => {
      const d = await getNewsDetail();

      if (encodeURI(d.seoUrlTitle) !== encodeURI(seoUrlTitle)) {
        navigate("/notFound");
      } else {
        setNewsDetail(d);
      }
    };
    fetchApiNews();
  }, [seoUrlTitle]);
  let delay = 0;
  return (
    <>
      {isLoadingNews ? (
        <LoadingPage />
      ) : (
        <div className="article-detail">
          <div className="content">
            <div className="left">
              <p>{newsDetail?.title}</p>
              <span className="span">{newsDetail?.summary}</span>
              <span className="date">
                {allNews &&
                  allNews?.items &&
                  allNews?.items?.filter((f) => f.id === newsDetail?.id)[0]
                    ?.createDate}
              </span>
            </div>
            <div className="right">
              <img
                src={`${
                  window.Configs["ui-base-url"]
                }/Api/V1/ui/Content/Image?entityName=2&imageName=${
                  newsDetail && newsDetail?.image
                }`}
                alt="news pic"
              />
            </div>
          </div>

          <div
            className="article-detail-body"
            dangerouslySetInnerHTML={{ __html: newsDetail?.body }}
          ></div>

          <div className="last-news">
            <p className="title">خبرهای اخیر</p>
            <div className="card-container">
              {homeNews &&
                homeNews?.map((item, index) => {
                  delay += 250
                  return (
                    <ScrollAnimation key={index} animateIn="zoomIn" delay={delay}>
                      <div
                        className="cardd"
                        onClick={() =>
                          navigateHandler(
                            `/newsDetail/${item.id}/${item.seoUrlTitle}`
                          )
                        }
                      >
                        <div className="img-container">
                          <img
                            src={`${
                              window.Configs["ui-base-url"]
                            }/Api/V1/ui/Content/Image?entityName=2&imageName=${
                              item?.image && item?.image
                            }`}
                            alt="pic-news"
                          />
                        </div>
                        <div className="contentt">
                          <p className="p">{truncate(item.title, 65)}</p>
                          <p className="span">{truncate(item.summary, 215)}</p>
                          <span className="date">{item.createDate}</span>
                        </div>
                      </div>
                    </ScrollAnimation>
                  );
                })}
            </div>
          </div>

          <FooterTwo />
        </div>
      )}
    </>
  );
};

export default ArticleDetail;
